var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eGalleryQuestionGroup"},[_vm._l((_vm.testObj.questions[_vm.current_question_group_idx]),function(question,idx){return [_c('question',{attrs:{"testObj":_vm.testObj,"question":question,"question_group_idx":_vm.current_question_group_idx,"question_idx":idx}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }